import { isOnlineStoreChannel } from "@app/shared/constants/channel.constants";

export type PackageOwner = "enrichment" | "online-store";

/** Product lines whose packages Online Store edits and publishes on its own
 *  channel, lowercased. */
const ONLINE_STORE_PRODUCT_LINES: ReadonlySet<string> = new Set([
  "mobile",
  "broadband",
  "digital services",
  "digital service",
]);

/** Who edits and publishes a package of `productLine` under `channel`. */
export function packageOwner(
  productLine: string | null | undefined,
  channel: string | null | undefined,
): PackageOwner {
  return ONLINE_STORE_PRODUCT_LINES.has(
    (productLine ?? "").trim().toLowerCase(),
  ) && isOnlineStoreChannel(channel)
    ? "online-store"
    : "enrichment";
}
